import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import config from "../config";

const useFetchProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const currentLang = location.pathname.split("/")[1] || "fr"; // Récupère la langue dans l'URL

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}/api/projects?lang=${currentLang}`);
        if (!response.ok) {
          throw new Error("Erreur lors de la récupération des projets");
        }
        const data = await response.json();
        console.log(data)
        setProjects(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [currentLang]); // Refetch quand la langue change

  return { projects, loading, error, currentLang };
};

export default useFetchProjects;
